import LegalPage from "./legalPage";
import { useTranslation } from "../../../../i18n/useTranslation";

const Terms = () => {
  const { t } = useTranslation();
  return <LegalPage title={t("legalTerms.title")} sections={t("legalTerms.sections")} />;
};

export default Terms;
